exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display{\r\n    display: none;\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/entities/entities.component.css
// module id = ../../../../../src/app/pages/entities/entities.component.css
// module chunks = main